import React from 'react'; 
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, Tabs, message, Collapse } from 'antd';
import { LoadingComponent } from '../../utils/ui'
import { getNameAsset } from '../../components/adms/helper';
import AssetData from '../../components/adms/AssetData'
import TaxonomyCard from '../../components/skos/TaxonomyValues'
import { AdmsRepository, AdmsAsset, ModelViews} from '../../redux';
import WikiValues from '../../components/wiki/WikiValues';
import AssetDistributions from '../../components/adms/AssetDistributions';
import DetailLinkCard from '../../components/adms/DetailLinkCard';
import ViewsProxy from '../models/ViewsProxy';
import AddPropertyForm from '../../components/adms/AddProperty';
import ProcessInstaceLink from '../../components/lifecycle/ProcessInstaceLink';

// import GraphComponent from '../graph/GraphComponent';
// import { getGraphViewId } from '../../utils/viewsUtil'

const ButtonGroup = Button.Group;
const { confirm } = Modal;
const { TabPane } = Tabs;
const { Panel } = Collapse;
//const asset_json = {"id":"http://hbz.ru/adms/foaf"};
//const asset_json2 = {"name":"FOAF","description":"Машиночитаемая онтология, описывающая людей, их деятельность и их отношения к другим людям и объектам.","id":"http://hbz.ru/adms/foaf","version":"0.1"};
//const sparql = {endpoint: "http://sparql.semanticpro.org/sparql", graph: "http://thezaurus.hbz.local", sparql: "select ?s ?p ?o where { ?s ?p ?o }"};
//const foaf_sparql = {endpoint: "http://sparql.semanticpro.org/sparql", graph: "http://www.foaf-project.org", sparql: "select ?s ?p ?o where { ?s ?p ?o }"};
//const skos_sparql = {endpoint: "http://sparql.semanticpro.org/sparql", graph: "http://www.w3.org/2004/02/skos/core", sparql: "select ?s ?p ?o where { ?s ?p ?o }"};
// const rdfs_sparql = {
//   endpoint: "http://sparql.semanticpro.org/sparql", 
//   graph: "http://www.w3.org/2000/01/rdf-schema#", 
//   sparql: "select ?s ?p ?o where { ?s ?p ?o }",
//   settings:{
//     //Узлы, которых надо создавать (указываются типы узлов). Т.е. s, которые имеют значение o для предиката http://www.w3.org/1999/02/22-rdf-syntax-ns#type
//     createNodes:["http://www.w3.org/2000/01/rdf-schema#Datatype", "http://www.w3.org/2000/01/rdf-schema#Class", "http://www.w3.org/1999/02/22-rdf-syntax-ns#List", "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property"],
//     //Типы, которые надо создавать. Т.е. значения o для предиката http://www.w3.org/1999/02/22-rdf-syntax-ns#type
//     createTypes:["http://www.w3.org/2000/01/rdf-schema#Class", "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property"],
//     //Флаг, что тип определяет родительский класс. Т.е. устанавливается связь rdfs:SubClassOf
//     typeAsSuperClass: true
//   }
// };
// const rdf_sparql = {
//   endpoint: "http://sparql.semanticpro.org/sparql", 
//   graph: "http://www.w3.org/1999/02/22-rdf-syntax-ns#", 
//   sparql: "select ?s ?p ?o where { ?s ?p ?o }",
//   settings:{
//     //Узлы, которых надо создавать (указываются типы узлов). Т.е. s, которые имеют значение o для предиката http://www.w3.org/1999/02/22-rdf-syntax-ns#type
//     createNodes:["http://www.w3.org/2000/01/rdf-schema#Datatype", "http://www.w3.org/2000/01/rdf-schema#Class", "http://www.w3.org/1999/02/22-rdf-syntax-ns#List", "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property"],
//     //Типы, которые надо создавать. Т.е. значения o для предиката http://www.w3.org/1999/02/22-rdf-syntax-ns#type
//     createTypes:["http://www.w3.org/2000/01/rdf-schema#Class", "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property"],
//     //Флаг, что тип определяет родительский класс. Т.е. устанавливается связь rdfs:SubClassOf
//     typeAsSuperClass: true
//   }
// };
// const dc11_sparql = {
//   endpoint: "http://sparql.semanticpro.org/sparql", 
//   graph: "http://purl.org/dc/elements/1.1/", 
//   sparql: "select ?s ?p ?o where { ?s ?p ?o }",
//   settings:{
//     //Типы, которые надо создавать. Т.е. значения o для предиката http://www.w3.org/1999/02/22-rdf-syntax-ns#type
//     createTypes:["http://www.w3.org/1999/02/22-rdf-syntax-ns#Property"],
//     //Флаг, что тип определяет родительский класс. Т.е. устанавливается связь rdfs:SubClassOf
//     typeAsSuperClass: true
//   }
// };

const catalog = "http://hbz.ru/adms/catalog";

function callback(key) {
  console.log(key);
}

const AssetTitle = names => {
    const single = names.length = 1;
    return (single)? names[0]: <span>names.map(name=> <p>{name}</p>)</span>;
}

/**
 * 
 * @param {*} formRef 
 * @param {*} IRI - текущий выбранный элемент (IRI)
 * @param {*} factory - фабрика получения информкции о списка доступных свойств и их аннотации
 * @param {*} existing - массив существующих у объекта свойств (предикат + объекта)
 * @param {*} lang  - текущий язык
 * @param {*} onFinishOperation - callback для добавления
 * @param {*} onCancelOperation - callback для отмены
 * @returns 
 */
const showAddProperty = (formRef=f=>f, IRI, existing, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} visible={true} title="Добавление свойства" cancelText="Отмена" okText="Ок" 
		onCancel={onCancelOperation} onOk={onFinishOperation}>
        <AddPropertyForm wrappedComponentRef={formRef} IRI={IRI} existing={existing} 
          factory={factory} rdfType="http://www.w3.org/ns/dcat#Dataset" lang={lang}/>
	  </Modal>
}

const showViewDetail = (formRef=f=>f, selected, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} visible={true} title="Детальная информация" cancelText="Отмена" okText="Ок" 
		onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, dispaly: "none" }}>
        <DetailLinkCard triplet={selected} factory={factory}/>
	  </Modal>
}

const decodeIRIParams = match =>{
  return (match && match.params && match.params.id)?decodeURIComponent(match.params.id):null;
}

/** Карточка актива. Отображаются данные из vasset.
 * обеспечивает загрузку данных по ассету, так как дочерние компоненты должны используать уже загруженные данные.
 * Так же контролирует отображение в режимах редактирования и перевода.
 * 
 * 20200530 см. https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
 * перевод для асинхронного вызова загрузки карточки 
 */
class AssetCard extends React.Component {
  
  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false, 			  //Флаг загрузки, карточки ADMS
      operation: "view",    //Текущая операция над карточкой
      detail: undefined,    //Элемент, для которого требуется получение дополнительной информацией
      adding: false,        //Флаг, для отображения далога добавления нового свойства
      views: false,         //Загружены представления содержимого актива
    }
  }
   
  static getDerivedStateFromProps(props, state) {
    //console.log("AssetCard.js static getDerivedStateFromProps(props, state)", decodeIRIParams(props.match), props.IRI, props.state, props, state);
    if ((decodeIRIParams(props.match)!=props.IRI)||(props.state=="empty") || !props.IRI){
    //||(props.vviews && (props.vviews.iri != props.IRI))) {
      return {loaded: false, operation: "view", detail: undefined, adding: false};
    }
    if ((decodeIRIParams(props.match)==props.IRI)||(props.state=="loaded")){
        return { ...state, loaded: true}
    }
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    const IRI = decodeIRIParams(this.props.match);
    if (!this.state.loaded && (IRI!=this.props.IRI) || (this.props.state=="empty")){
      Promise.all([this.props.onReload(AdmsAsset, catalog, IRI),this.props.onReloadViews(ModelViews, IRI)]);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const IRI = decodeIRIParams(this.props.match);
    if (!this.state.loaded && ((IRI!=this.props.IRI)||(this.props.state=="empty") || !this.props.IRI))
      //Promise.all([this.props.onReload(AdmsAsset, catalog, IRI),this.props.onReloadViews(ModelViews, rpc_url, IRI)]);
      this.props.onReload(AdmsAsset, catalog, IRI).then( response => {
        this.props.onReloadViews(ModelViews, IRI).then(views => {
          this.setState({views: true});
        });
      });
  }

  modalFormRef = formRef => {
    this.formRef = formRef;
  }
    
  onSelectOperation(e, operation) { 
    e.preventDefault();
    const { IRI, values, lang, factory, onDeleteElement, onUnlinkElement, history} = this.props;
    if (operation=="delete"){
            confirm({ title: 'Удалить выбранный элемент', content: getNameAsset(values, lang), 
                okText: 'Да', okType: 'danger', cancelText: 'Нет',
                onOk() { 
                    onDeleteElement(AdmsRepository, catalog, IRI)
                    .then (result =>{
                        console.log("onDeleteElement", result);
                        message.success("Запись удалена.");
                        if (history)
                            history.push("/adms");
                    })
                },
                onCancel() {},
              });
            return;
    };
    if (operation=="unlink"){
            confirm({ title: 'Исключить элемент из каталога (разорвать связь с каталогом)', content: getNameAsset(values, lang), 
                okText: 'Да', okType: 'danger', cancelText: 'Нет',
                onOk() {
                    onUnlinkElement(AdmsRepository, catalog, IRI)
                    .then (result =>{
                        console.log("onUnlinkElement", result);
                        message.success("Связь удалена.");
                    })
                },
                onCancel() {},
              });
            return;
    };
    //Добавление нового свойства
    if (operation=="add"){
      this.setState({operation, adding: true});
      return;
    };
    this.setState({operation});
  }

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    e.preventDefault();
    if (operation== "detail" && this.props.onDetailElement) 
      this.props.onDetailElement(AdmsAsset, catalog, triplet)
      .then (result =>{
        //console.log("handlers(e, triplet, operation)", result);
        this.setState({detail: triplet});
    });
  }

  cancelOperation(){
    //console.log('AssetCard.js cancelOperation ', this);
    this.setState({detail: undefined, adding: false, operation: "view"});
  }

  /** Вызывается при добавлении нового свойства. Данные см. AddProperty.js */
  submitAddProperty(operation) {
    this.setState({detail: undefined, adding: false, operation: "view"});
    const { form } = this.formRef.props;
    //console.log('AssetCard.js submitOperation ', this, operation, form);
    form.validateFields((err, values) => {
      if (err) return; console.log("Received values of form: ", values);
      const predicat = values.IRI;
      this.props.onAddProperty(AdmsAsset, this.props.IRI, predicat, this.props.lang)
          .then (response =>{ 
            //const time = showMessageSuccess(store, "Добавление записи завершено успешно.");
            message.success("Добавление свойства завершено успешно.");
            this.setState({detail: undefined, adding: false, operation: "view"});
            this.props.onReload(AdmsAsset, catalog, this.props.IRI);
          })
          .catch(e => {  message.error(`Ошибка при добавления свойства в каталог. ${e}`); });                  
    });
  };

  render() {
    let { loaded, operation, detail, adding} = this.state;
    const { values, lang, factory, history, IRI, vviews, isSignedIn} = this.props;
    const asset_json = {id: IRI};
    //Флаг, что есть представление для отображение содержимого 
    const views = vviews && Array.isArray(vviews.views) && vviews.views.length>0;
    //Представления, которые могут быть отображены
    const showViews = (views)? vviews.views.filter(view => !view.hide_in_list): vviews.views;
    //Описание view, если оно одно в списке
    const view = (views && showViews.length==1)? showViews[0]: undefined;
    console.log(this); //console.log(JSON.stringify(values)); console.log(lang);
    //{AssetTitle(getNameAsset(values, lang))}
    return (
      (!loaded? <LoadingComponent />:
        <span>
          <Row>
            <Col className="asset_title" span={16}>{AssetTitle(getNameAsset(values, lang))}</Col>
          </Row>
          <Row>
            <Tabs onChange={callback} type="card">
              <TabPane tab={i18n.t('views.adms.card_tab_card')} key="1">
                <div className="csi_wrapper_content csi_inner_asset" resource={IRI}>
                    <Row>
                        <Col className="asset_title" span={16}></Col>
                        <Col className="asset_title_buttons" span={8}>
                          {isSignedIn &&(
                            <ButtonGroup>
                                <Tooltip placement="top" title={"Режим просмотра данных"}>
                                    <Button icon="credit-card" onClick={(e)=> this.onSelectOperation(e, "view")} disabled={operation=="view"}></Button>
                                </Tooltip>
                                <Tooltip placement="top" title={"Добавление свойства"}>
                                    <Button icon="file-add" onClick={(e)=> this.onSelectOperation(e, "add")} disabled={operation=="add"}></Button>
                                    {adding && showAddProperty(this.modalFormRef, IRI, values, factory, lang, ()=>this.submitAddProperty(operation), ()=>this.cancelOperation())}
                                </Tooltip>
                                <Tooltip placement="top" title={"Редактирование или удаление свойства"}>
                                    <Button icon="edit" onClick={(e)=> this.onSelectOperation(e, "edit")} disabled={operation=="edit"}></Button>
                                </Tooltip>
                                <Tooltip placement="top" title={"Перевод свойств"}>
                                    <Button icon="font-size" onClick={(e)=> this.onSelectOperation(e, "translate")}  disabled={operation=="translate"}></Button>
                                </Tooltip>
                                <Tooltip placement="top" title={"Удалить элемент из каталога."}>
                                    <Button icon="close" onClick={(e)=> this.onSelectOperation(e, "delete")}  disabled={operation=="delete"}></Button>
                                </Tooltip>
                                <Tooltip placement="top" title={"Разорвать связь с каталогом."}>
                                    <Button icon="radius-setting" onClick={(e)=> this.onSelectOperation(e, "unlink")}  disabled={operation=="unlink"}></Button>
                                </Tooltip>
                            </ButtonGroup>
                          )}
                        </Col>
                    </Row>
                    <Row>
                        <Col className="assetCardTable" span={16}>
                          <AssetData operation={operation} factory={factory} handlers={(e,t,o)=> this.handlers(e,t,o)}/> 
                          {detail && showViewDetail(this.modalFormRef, detail, factory, ()=>this.cancelOperation(), ()=>this.cancelOperation())}
                        </Col>
                        <Col className="properties_panel_wrapper" span={8}>
                        <Row>
                          <Col span={24}>
                            <TaxonomyCard operation={operation} predicat="http://www.w3.org/ns/dcat#theme" factory={factory} />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <WikiValues operation={operation} predicat="http://aaaa" factory={factory} />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <AssetDistributions operation={operation} factory={factory} history={history}/>
                          </Col>
                        </Row>
                        </Col>
                    </Row>
                </div>            
        </TabPane>
        <TabPane tab={i18n.t('views.adms.card_tab_collaboration')} key="2">
          <div className="csi_wrapper_content csi_inner_asset">
            <Row>
              <Collapse accordion>
                <Panel header={i18n.t('views.adms.collaboration.lifecycle_header')} key="1">
                  <ProcessInstaceLink IRI={IRI} />            
                </Panel>
                <Panel header={i18n.t('views.adms.collaboration.event_header')} key="2">
                  <p><b>{i18n.t('views.adms.collaboration.event_none')}</b></p>
                </Panel>
                <Panel header={i18n.t('views.adms.collaboration.wiki_header')} key="3">
                  <WikiValues operation={operation} predicat="http://hbz.ru/wiki" factory={factory} />
                </Panel>
              </Collapse>
            </Row>
          </div>            
        </TabPane>
        {views && (<TabPane tab={i18n.t('views.adms.card_tab_content')} key="3"><ViewsProxy rpc_url={ModelViews.getRpc_url()} asset={asset_json} view={view} /></TabPane>)}
      </Tabs>
      </Row>
      </span>
      )
    )
  }
}

//{(viewGraphID & false) && (<TabPane tab="Граф" key="4"><GraphComponent view={{id: viewGraphID}} {...vviews} /></TabPane>)}
// {(IRI=="http://hbz.ru/adms/foaf") &&  <TabPane tab="Граф" key="4"> <GraphComponent settings={foaf_sparql} type="owl"/></TabPane>}
// {(IRI=="http://hbz.ru/adms/skos") &&  <TabPane tab="Граф" key="4"> <GraphComponent settings={skos_sparql} type="owl"/></TabPane>}
// {(IRI=="http://voc.hbz.ru/thesaurus") && <TabPane tab="Граф" key="4"><GraphComponent settings={sparql}/></TabPane>}
// {(IRI=="http://hbz.ru/adms/rdf") &&  <TabPane tab="Граф" key="4"> <GraphComponent settings={rdf_sparql} type="owl"/></TabPane>}
// {(IRI=="http://hbz.ru/adms/rdfs") &&  <TabPane tab="Граф" key="4"> <GraphComponent settings={rdfs_sparql} type="owl"/></TabPane>}
// {(IRI=="http://purl.org/dc/terms/1") &&  <TabPane tab="Граф" key="4"> <GraphComponent settings={dc11_sparql} type="owl"/></TabPane>}        

export default AssetCard;